import React from "react";
import CardTable from "../../components/table/CardTable";
import columns from "./config/PartsTableConfig";
import { useTranslation } from 'react-i18next';

const PartsTable = ({
                        format,
                        setLoader,
                        readOnly,
                        short,
                        checked,
                        extended,
                        setChecked,
                        additionalFilter,
                        title,
                        noDisableRule,
                        twin,
                        cleaning,
                        width,
                        reload,
                        className,
                        showStatusAlways,
                        externalState,
                    }) => {

    const { t } = useTranslation();

    return (
        <>
            {format &&


                <CardTable
                    title={title || t("forms.all_format_parts")}
                    columns={columns(extended, short, twin, cleaning, t)}
                    width={width || 12}
                    pagination={true}
                    withoutHeader={twin ? false : readOnly}
                    setLoader={setLoader}
                    checked={checked}
                    readOnly={readOnly}
                    additionalFilter={additionalFilter}
                    setChecked={setChecked}
                    reload={reload}
                    striped={false}
                    showAlways={showStatusAlways ? ["status"] : []}
                    source={"/format/" + format.id + "/parts"}
                    className={className}
                    externalState={externalState}
                    disableRule={(row) => {
                        return noDisableRule ? false : row.status !== "STORAGE" && !readOnly;
                    }}
                    shadow={true}
                />
            }

        </>
    );
};


export default PartsTable;